import { createSelector } from '@ngrx/store';
import { usersAdapter, usersFeature } from './user.reducer';

const { selectAll, selectEntities } = usersAdapter.getSelectors();

export const {
  selectUsersState,
  selectLoading: selectUsersLoading,
  selectError: selectUsersError,
  selectTotal: selectUsersTotal,
  selectPage: selectUsersPage,
  selectLimit: selectUsersLimit,
  selectMyTenants,
  selectMyTenantsLoading,
  selectMyTenantsError,
} = usersFeature;

export const selectAllUsers = createSelector(usersFeature.selectUsersState, selectAll);
export const selectUserEntities = createSelector(usersFeature.selectUsersState, selectEntities);
